export default "__VITE_ASSET__5QkaYvn4__"